import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useToast } from '@/components/ui/use-toast';
import { authService } from '@/services/authService';

export default function ManagerLoginPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      toast({
        variant: 'destructive',
        title: 'Hata',
        description: 'Geçersiz token'
      });
      navigate('/login');
      return;
    }

    // Token'ı doğrula
    authService.loginWithToken(token)
      .then(() => {
        // Başarılı giriş
        navigate('/dashboard');
      })
      .catch((error) => {
        console.error('Login error:', error);
        toast({
          variant: 'destructive',
          title: 'Hata',
          description: 'Giriş yapılırken bir hata oluştu'
        });
        navigate('/login');
      });
  }, [searchParams, navigate, toast]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h1 className="text-2xl font-semibold mb-4">Giriş yapılıyor...</h1>
        <p className="text-muted-foreground">Lütfen bekleyin, yönlendiriliyorsunuz.</p>
      </div>
    </div>
  );
}
